import { gql } from "@apollo/client"
import { DEFAULT_GRAPHQL_RESPONSE } from "../../../constants"

export const MUTATION = gql`
  mutation ChangeFeeStatus($input: FeeStatusEditingInput!) {
    ${DEFAULT_GRAPHQL_RESPONSE}: editFeeStatus(input: $input)
  }
`
